export default [{
    path: '/statistiques/',
    name: 'statistiques',
    component: () => import('@/views/assureur/statistiques/Statistiques.vue'),
},
]